home-page-title = Übersicht
home-page-greeting = Hallo { $name },
home-page-breadcrumb = Dashboard
home-page-header-home-link = Übersicht

home-page-actions =
  { $action ->
    *[x_unknown] [{$action}]
    [new-request] Neue Beratung starten
    [delete-account] Mein Konto löschen
    [view-dialog] Dialog einsehen
    [to-dialog] Zum Dialog
  }

home-page-current-requests-title = Ihre Beratungsanliegen

home-page-create-mail-title =
  { $state ->
    *[x_unknown] [{$state}]
    [new] Neue Beratung starten
    [locked] Ihr aktuelles Anliegen wird noch bearbeitet
    [closed] Neue Beratung starten
  }
home-page-create-mail-description =
  { $state ->
    *[x_unknown] [{$state}]
    [new] Erzählen Sie uns, wobei Sie Beratung benötigen – ein:e Patientenberater:in wird sich persönlich um Ihr Anliegen kümmern.
    [locked] Sobald Ihr laufendes Beratungsanliegen abgeschlossen ist, können Sie hier eine neue Beratung starten.
    [closed] Ihre bisherigen Beratungen sind abgeschlossen. Wenn Sie ein weiteres Anliegen haben starten Sie eine neue Beratung.
  }

home-page-closed-requests-title = Abgeschlossene Beratungsanliegen
help-seeker-request-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [first_mail] Erstellt am
    [latest_message] Zuletzt aktualisiert am
    [state] Status
  }

help-seeker-request-status =
  { $status ->
    *[x_unknown] [{$status}]
    [active] Aktive Beratung
    [closed] Abgeschlossene Beratung
  }

help-seeker-cancel-mail-dialog-heading = Beratungsanfrage stornieren?
help-seeker-cancel-mail-dialog-message = Dadurch werden alle Informationen gelöscht, die Sie in den Formularen angegeben haben.
help-seeker-cancel-mail-dialog-confirm = Ja, stornieren

home-page-delete-account-dialog-title = Account dauerhaft löschen
home-page-delete-account-success = Ihr Konto wird nach 72 Stunden gelöscht.
home-page-delete-account-message = Möchten Sie Ihren Account und die hier gespeicherten Informationen dauerhaft löschen? Damit verlieren Sie den Zugang zu Ihren aktiven und geschlossenen Fällen.
home-page-delete-account-confirm = Jetzt löschen
